import { Paperclip } from "lucide-react";
import type { Message } from "../../types/message";
import { MessageBubble } from "./message-bubble";

export default function FileMessage({ message }: { message: Message }) {
  if (!message.url) return null;

  const caption = message.caption?.trim();

  return (
    <MessageBubble message={message}>
      <div className="flex flex-col gap-2">
        <a
          href={message.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center gap-2 hover:underline ${
            message.role === "user"
              ? "text-blue-600 hover:text-blue-700"
              : "text-slate-100 hover:text-white"
          }`}
        >
          <Paperclip size={16} />
          <span>{message.fileName}</span>
        </a>

        {caption ? (
          <p
            className={`whitespace-pre-wrap text-sm leading-snug ${
              message.role === "user" ? "text-slate-700" : "text-slate-100"
            }`}
          >
            {caption}
          </p>
        ) : null}
      </div>
    </MessageBubble>
  );
}
